import "../css/style.css";
import './modules/style';
import {default as stickyNav} from './modules/stickynav';
import {default as commonScripts} from './modules/default';
$(function(){
	stickyNav();
	commonScripts();
});
